export const iconFontAwesomeMoneyCashRegister = (
	<i className="fa-solid fa-cash-register"></i>
);
